import type { ReactNode } from "react";

interface IConfigSectionWrapperV2Props {
  icon: ReactNode;
  headerTitle: string;
  headerButton?: ReactNode;
  danger?: boolean;
  children?: ReactNode;
}

const ConfigSectionWrapperV2 = ({
  icon,
  headerTitle,
  headerButton,
  danger,
  children,
}: IConfigSectionWrapperV2Props) => {
  return (
    <div
      className={`flex flex-col rounded-xl shadow-xs ${danger ? 'bg-error-v2-100' : 'bg-gray-v2-100'}`}
    >
      <div
        className={`px-4 py-3 flex justify-between rounded-t-xl`}
      >
        <div className="flex items-center gap-2">
          {icon}
          <span className="text-gray-v2-900 text-lg font-semibold">{headerTitle}</span>
        </div>
        <div className="flex gap-2">{headerButton}</div>
      </div>
      <div className={`rounded-b-xl`}>
        <div className={`rounded-xl bg-white border ${danger ? 'border-error-v2-200' : 'border-gray-v2-200'}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ConfigSectionWrapperV2;
